function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_655",
  "data-name": "Group 655",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_397",
  "data-name": "Path 397",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_398",
  "data-name": "Path 398",
  d: "M4.828 21l-.02.02-.021-.02h-1.8A.993.993 0 012 20.007V3.993A1 1 0 012.992 3h18.016a.993.993 0 01.992.993v16.014a1 1 0 01-.992.993zM20 15V5H4v14L14 9zm0 2.828l-6-6L6.828 19H20zM8 11a2 2 0 112-2 2 2 0 01-2 2z",
  fill: "#bebebe"
})));